const isAggregationResponse = (obj) => {
    return (obj._shards !== undefined &&
        obj.aggregations !== undefined);
};
export default isAggregationResponse;
